import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'

const nonProdConfig = {
	apiKey: 'AIzaSyD53pUYBd_A6A5Lra4CJne3zEtNuFxIHAU',
	authDomain: 'non-prod-lexicon-labs.firebaseapp.com',
	projectId: 'non-prod-lexicon-labs',
	storageBucket: 'non-prod-lexicon-labs.firebasestorage.app',
	messagingSenderId: '145859632134',
	appId: '1:145859632134:web:f2af62f8c42884caeff787',
}

const prodConfig = {
	apiKey: 'AIzaSyB3FPzMrFHT_qXnoEEpisOd2iOrSrpPVnA',
	authDomain: 'mockingbird-7704d.firebaseapp.com',
	projectId: 'mockingbird-7704d',
	storageBucket: 'mockingbird-7704d.firebasestorage.app',
	messagingSenderId: '957227335576',
	appId: '1:957227335576:web:ffbc1bbe219fb38a4575ed',
	measurementId: 'G-0XP9CDW12M',
}

const firebaseApp = initializeApp(
	process.env.REACT_APP_ENV === 'production' ? prodConfig : nonProdConfig
)
export const auth = getAuth()
export const db = getFirestore(firebaseApp)
export const storage = getStorage(firebaseApp)
export const BASE_COLLECTION = 'mockingbird'
